import moment from 'moment-timezone';
import { ConsumptionMeasure, FormattedConsumptionData, IntervalType, UnitFormat, UnitSystem } from 'model';
import { FloChartFormatterFunction } from 'components';

export const defaultChartData: FormattedConsumptionData = {
  unitSystem: UnitFormat.displayLongVolumeUnit(UnitSystem.IMPERIAL),
  xAxis: ['12 am', '01 am', '02 am', '03 am', '04 am', '05 am', '06 am', '07 am', '08 am', '09 am', '10 am', '11 am',
  '12 pm', '01 pm', '02 pm', '03 pm', '04 pm', '05 pm', '06 pm', '07 pm', '08 pm', '09 pm', '10 pm', '11 pm'
  ],
  values: new Array(30).fill(0)
}

export function xAxisFormatByPeriod(intervalType: IntervalType): string {
  switch(intervalType) {
    case IntervalType.HOURS:
      return 'hh a';
    case IntervalType.DAYS:
      return 'dddd';
    case IntervalType.WEEKS:
      return 'dd';
    case IntervalType.MONTHS:
      return 'MMM';
    default:
      return 'MM/DD/YYYY hh:mm a';
  };
}

function tooltipFormatter(unit: UnitSystem, labelsGenerator?: (params: Array<any>) => {date: string}): FloChartFormatterFunction {
  return (params, ticket, callback) => {
    const axisValues = params[0].axisValue.split( /\n/ );
    const color = (seriesId: number) => params[seriesId].color;
    const consumed = params[0].data;
    const labels = {
      date: axisValues[0],
      ...(labelsGenerator ? labelsGenerator(params) : {}),
    }

    return tooltipDetail(labels.date as string, consumed, UnitFormat.displayShortVolumeUnit(unit), color(0));
  };
}

function tooltipDetail(label: string, value: string, unit: string, color: string) {
  const dotStyle = `display:inline-block;border-radius:5px;width:10px;height:10px;margin-right:2px;background:${ color };`;

  return `<span style="${ dotStyle }"></span>${ label }: ${ value } ${ unit }`;
}

function customTootltipFormatter(intervalType: IntervalType, unit: UnitSystem, startDate: string, timezone: string): FloChartFormatterFunction {
  return tooltipFormatter(unit, (params: Array<any>) => {
    let formattedDate;
    if (intervalType === IntervalType.HOURS) {
      const date = moment(startDate).add(Math.floor(params[0].dataIndex / 24), 'days');
      formattedDate = `${date.tz(timezone).format('dddd M/D')} ${params[0].axisValue}`;
    } else {
      const date = moment(startDate).add(params[0].dataIndex, 'days');
      formattedDate = `${date.tz(timezone).format('dddd')} (${date.tz(timezone).format('M/D')})`
    }
    return {
      date: formattedDate,
    };
  });
}

export function getXAxis(intervalType: IntervalType, data: ConsumptionMeasure[], timezone: string): string[] {
  return data.map(x => moment(x.time).tz(timezone).format(xAxisFormatByPeriod(intervalType)));
}

export function buildTooltipFormatter(intervalType: IntervalType, unit: UnitSystem, startDate: string, timezone: string): FloChartFormatterFunction {
  if ([IntervalType.HOURS, IntervalType.WEEKS, IntervalType.DAYS].includes(intervalType)) {
    return customTootltipFormatter(intervalType, unit, startDate, timezone);
  }

  return tooltipFormatter(unit);
}

export function formatTableDate(type: IntervalType, isDownload: boolean = false): string {
  switch (true) {
    case !isDownload && type === IntervalType.HOURS:
      return 'MM/DD HH:mm';
    case !isDownload && type === IntervalType.MONTHS:
      return 'MMM';
    case !isDownload:
      return 'YYYY/MM/DD';
    default:
      return 'YYYY-MM-DD HH:mm:ss'
  }
}
